import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'verifiedBoxesList': [],
};

export const verifyBox = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.VERIFYING_BOX]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.VERIFIED_BOX]: (state, action) => ({
      ...state,
      'loading': false,
      'verifiedBoxesList': action.response.data,
    }),
    [ActionTypes.VERIFIED_BOX_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'verifiedBoxesList': [],
    }),
  })(state, action);
};
